// logged-in.providers.ts
import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { NotificationCenterContext } from '#core/components/notification-center/context/notification-center.context';
import { RoiNotificationsContext } from '#core/components/notification-center/context/roi-notification.context';
import { HeaderStore } from '#core/components/sidenav/store/header.store';
import { AbilitiesContext } from '#core/context/abilities.context';
import { OrganizationPermissionsService } from '#core/services/organization-permissions.service';
import { StatisticsPermissionsService } from '#core/services/statistics-permissions.service';
import { SessionStore } from '#core/store/session.store';
import { CampaignPermissionsService } from '#modules/crm/campaigns/services/campaign-permissions.service';
import { FeedbackFormsPermissionsService } from '#modules/feedback-forms/services/feedback-forms-permissions.service';
import { GalleryImportMediaStore } from '#modules/gallery/stores/gallery-import-media.store';
import { KeywordsPermissionsService } from '#modules/keywords/services/keywords-permissions.service';
import { MessagesService } from '#modules/messages/services/messages.service';
import { MessagesStore } from '#modules/messages/stores/messages.store';
import { TotemPermissionsService } from '#modules/nfcs/services/totem-permissions.service';
import { OrganizationEmailSenderPermissionsService } from '#modules/organization-email-sender/services/organization-email-sender-permissions.service';
import { SocialPostsPermissionsService } from '#modules/posts/services/social-posts-permissions.service';
import { RestaurantsStore } from '#modules/restaurants/stores/restaurants.store';
import { RoiContext } from '#modules/roi/contexts/roi.context';
import { MessageTemplatesStore } from '#modules/templates/views/message-templates/store/message-templates.store';
import { ReviewTemplatesStore } from '#modules/templates/views/review-templates/store/review-templates.store';
import { WheelOfFortunePermissionsService } from '#modules/wheels-of-fortune/services/wheel-of-fortune-permissions.service';
import { RouterListenerService } from '#shared/services/router-listener.service';

export function provideLoggedInScope(): EnvironmentProviders {
    return makeEnvironmentProviders([
        SessionStore,
        RouterListenerService, // for heap tracking when navigating to /groups
        AbilitiesContext,
        SocialPostsPermissionsService,
        CampaignPermissionsService,
        WheelOfFortunePermissionsService,
        TotemPermissionsService,
        FeedbackFormsPermissionsService,
        KeywordsPermissionsService,
        StatisticsPermissionsService,
        OrganizationPermissionsService,
        OrganizationEmailSenderPermissionsService,
        RoiNotificationsContext,
        NotificationCenterContext,
        RoiContext,
        GalleryImportMediaStore,
        ReviewTemplatesStore,
        MessageTemplatesStore,
        MessagesStore,
        MessagesService,
        HeaderStore,
        RestaurantsStore,
    ]);
}
